import {webLinks} from '#/lib/constants'

export const DMCA_LINK = webLinks.copyright
export const SUPPORT_PAGE = webLinks.main
